import { makeStyles } from '@material-ui/styles';
// import tinycolor from 'tinycolor2';

export default makeStyles(theme => ({

    st0: {
        fill: 'url(#SVGID_1_)',
    },

    st1: {
        fill: '#154D93',
    },

    st2: {
        fill: '#FFFFFF',
    },

    st3: {
        fontFamily: 'Roboto, sans-serif',
        // fontFamily: 'Open Sans, sans-serif',
    },

    st4: {
        fontSize: '15px',
        // fontWeight: '600',
    },

    st5: {
        fill: '#F28C00',
    },

    st6: {
        fill: '#F9BF01',
    },

    st7: {
        fill: '#76BD22',
    },

    st8: {
        fill: '#00A8E2',
    },

}));
